import React from "react";
import "../styles/HomepageS7.css";

export default function HomepageS7() {
  const processSteps = [
    {
      number: "01",
      title: "Understand",
      description:
        "Clarify organizational context, risk, and desired outcomes.",
    },
    {
      number: "02",
      title: "Assess",
      description:
        "Review current strengths, gaps, evidence, and readiness.",
    },
    {
      number: "03",
      title: "Design",
      description:
        "Develop a solution suited to the organization and operating environment.",
    },
    {
      number: "04",
      title: "Integrate",
      description:
        "Connect governance, people, systems, evidence, and technology.",
    },
    {
      number: "05",
      title: "Enable",
      description:
        "Build internal capability through implementation, learning, and knowledge transfer.",
    },
    {
      number: "06",
      title: "Measure",
      description:
        "Track evidence, performance, adoption, and outcomes.",
    },
    {
      number: "07",
      title: "Improve",
      description:
        "Refine the approach and strengthen long-term resilience.",
    },
  ];

  return (
    // HOMEPAGE SECTION 7
    <section
      id="homepage-section-seven"
      className="homepage-s7"
      aria-labelledby="homepage-s7-title"
    >
      <div className="homepage-s7-background" aria-hidden="true">
        <span className="homepage-s7-glow homepage-s7-glow-left"></span>
        <span className="homepage-s7-glow homepage-s7-glow-right"></span>
      </div>

      <div className="homepage-s7-container">
        <div className="homepage-s7-heading">
          <p className="homepage-s7-kicker">
            Our Approach
          </p>

          <h2 id="homepage-s7-title" className="homepage-s7-title">
            From Complexity to
            <span> Practical Action</span>
          </h2>

          <p className="homepage-s7-intro">
            A connected seven-step process that turns complex safety needs into
            practical solutions, measurable progress, and lasting improvement.
          </p>
        </div>

        <ol
          className="homepage-s7-flow"
          aria-label="GalaxyEDGE Safety seven-step process"
        >
          {processSteps.map((step, index) => (
            <li
              className="homepage-s7-step"
              key={step.number}
              style={{ "--step-index": index }}
            >
              <div className="homepage-s7-node-row">
                <div className="homepage-s7-node">
                  <span className="homepage-s7-number">
                    {step.number}
                  </span>

                  <span
                    className="homepage-s7-node-glow"
                    aria-hidden="true"
                  ></span>
                </div>

                {index < processSteps.length - 1 && (
                  <span
                    className="homepage-s7-connector"
                    aria-hidden="true"
                  >
                    <span className="homepage-s7-connector-line"></span>
                    <span className="homepage-s7-connector-arrow">›</span>
                  </span>
                )}
              </div>

              <div className="homepage-s7-step-copy">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </li>
          ))}
        </ol>

        <div className="homepage-s7-outcome">
          <span
            className="homepage-s7-outcome-icon"
            aria-hidden="true"
          >
            ✓
          </span>

          <p>
            Each stage builds on the last, helping organizations move from
            insight to action and from action to lasting safety performance.
          </p>
        </div>
      </div>
    </section>
  );
}